import type { ReactElement } from 'react';
import type { Proposal } from '@shared/types';
import { formatMissingPriceItem, formatMissingPriceNote, missingPrices } from '../lib/missingPrices';

/**
 * V16 rate cards, phase 2b: a calm, separate note for lines with no price
 * yet — distinct from ValidationBanner's error/warning box (which excludes
 * MISSING_PRICE so it's never listed twice). Each item jumps to and opens
 * that tactic's plan page, where the inline price field lives.
 */
export function MissingPriceNote({
  proposal,
  onFocusProduct,
}: {
  proposal: Proposal;
  onFocusProduct: (productId: string) => void;
}): ReactElement | null {
  const items = missingPrices(proposal);
  if (items.length === 0) return null;

  return (
    <div className="missing-price-note" role="status">
      <span className="missing-price-note-label">{formatMissingPriceNote(items)}</span>
      <ul>
        {items.map((item) => (
          <li key={item.productId}>
            <button
              type="button"
              className="missing-price-note-item"
              onClick={() => onFocusProduct(item.productId)}
              title={`Price ${item.name}`}
            >
              {formatMissingPriceItem(item)}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
